module.exports = __webpack_public_path__ + "static/media/me.18d9f78c.jpg";